var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"fill-height",staticStyle:{"background-color":"#303030"}},[_c('apexchart',{staticClass:"ma-auto unset-font",attrs:{"options":_vm.weightChartOptions,"series":_vm.weightChartItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }